<script>
  import { fade, fly, slide } from "svelte/transition";
  import { linear } from "eases";
  import { windowIsMobile } from "../util/window-state";
  import CollapsePanelIcon from "./CollapsePanelIcon.svelte";
  export let mode = "expand";
</script>

<div
  class="hint-tool-tip"
  role="none"
  class:rotateDrag={!$windowIsMobile}
  class:drag={mode == "drag"}
  on:click={(ev) => {
    ev.preventDefault();
    // curToolTipHint = false;
    // local.set("edit-page-tooltip-visible", false);
  }}
>
  {#if mode == "expand"}
    Tap the
    <div class="collapse-icon-inline">
      <CollapsePanelIcon fitHeight rotate={$windowIsMobile} />
    </div>
    button to expand and collapse the editor.
  {:else if mode == "drag"}
    Drag the <div class="collapse-icon-inline">
      <CollapsePanelIcon fitHeight rotate={$windowIsMobile} />
    </div>
    button to change the size of the open panel.
  {/if}
</div>

<style>
  .collapse-icon-inline {
    line-height: 1;
    display: inline-block;
    /* background: red; */
    margin: 0;
    margin-left: -1px;
    margin-right: -1px;
    padding: 0;
    height: 16px;
    vertical-align: middle;
    overflow: hidden;
  }
  .hint-tool-tip {
    position: relative;
    /* cursor: pointer; */
    max-width: 200px;
    /* text-align: right; */
    background: white;
    padding: 10px;
    /* box-shadow:
      0px 3px 0px black,
      3px 3px 0px black,
      3px 0px 0px black; */
    border: 1px solid black;
    font-size: 12px;
    /* display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 10px; */
    background-color: var(--accent-color);
  }
  .hint-tool-tip.drag {
    animation: MoveUpDown 1.25s ease-in-out infinite;
  }
  .hint-tool-tip.drag.rotateDrag {
    animation: MoveLeftRight 1.25s ease-in-out infinite;
  }
  .hint-tool-tip::after {
    content: " ";
    position: absolute;

    --arrow-size: 10px;
    right: calc(-1px + 0px);
    bottom: calc(-1 * var(--arrow-size) - 1px);
    width: 0;
    height: 0;
    border-left: var(--arrow-size) solid transparent;
    border-right: var(--arrow-size) solid transparent;
    border-top: var(--arrow-size) solid black;
    /* height: 30px;
    width: 2px; */
    /* background: blue; */
    /* border-right: 2px solid black; */
  }

  @keyframes MoveLeftRight {
    0%,
    100% {
      transform: translateX(-5px);
    }
    50% {
      transform: translateX(5px);
    }
  }

  @keyframes MoveUpDown {
    0%,
    100% {
      transform: translateY(-5px);
    }
    50% {
      transform: translateY(5px);
    }
  }
</style>
